import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';

@Injectable({
  providedIn: 'root'
})
export class MigrateService {

  private api_synchronize = 'api/Stakeholder/Synchronize';
  private api_synchronize_status = 'api/Stakeholder/Synchronize/Status';
  private api_synchronize_cancel = 'api/Stakeholder/Synchronize/Cancel';

  constructor(private _authHttp: RestApi) { }

  public startSynchronization() {
    return this._authHttp.get(this.api_synchronize).toPromise();
  }
  public getSynchronizationStatus() {
    return this._authHttp.get(this.api_synchronize_status).toPromise();
  }
  public cancelSynchronization() {
    return this._authHttp.delete(this.api_synchronize_cancel).toPromise();
  }

}
